/** Компайл-тайм гарантия обработки всех видов Op. */
function assertNever(x) {
    throw new Error(`interpretOp: необработанный вид Op ${JSON.stringify(x)}`);
}
/**
 * Исполнить один дескриптор `Op` через переданный словарь операций `ops`
 * (bindOps с реальным state+очередью). Каждый Op → соответствующая ctx.ops.*.
 * Аргументы у Op явные (в т.ч. sourceId/ownerId), авто-подстановка контекста
 * не требуется.
 */
export function interpretOp(ops, op) {
    switch (op.op) {
        case 'dealDamage':
            ops.dealDamage(op.args.target, op.args.amount, op.args.sourceId);
            return;
        case 'createToken':
            ops.createToken(op.args.defId, op.args.ownerId, op.args.cellId);
            return;
        case 'addEffect':
            ops.addEffect({
                defId: op.args.defId,
                scope: op.args.scope,
                ...(op.args.duration !== undefined ? { duration: op.args.duration } : {}),
                ...(op.args.persistent !== undefined ? { persistent: op.args.persistent } : {}),
                ...(op.args.vars !== undefined ? { vars: op.args.vars } : {}),
            });
            return;
        case 'removeEffect':
            ops.removeEffect(op.args.effectId);
            return;
        case 'modifyStat':
            ops.modifyStat(op.args.instanceId, op.args.stat, op.args.delta);
            return;
        case 'moveUnit':
            ops.moveUnit(op.args.instanceId, op.args.toCellId);
            return;
        case 'moveCard':
            ops.moveCard(op.args.instanceId, op.args.to);
            return;
        case 'destroy':
            ops.destroy(op.args.instanceId);
            return;
        case 'applyHack':
            ops.applyHack(op.args.victimInstanceId, op.args.initiatorPlayerId, op.args.sourceInstanceId);
            return;
        case 'changeRule':
            ops.changeRule(op.args.key, op.args.value);
            return;
        default:
            return assertNever(op);
    }
}
//# sourceMappingURL=interpretOp.js.map